import ReactHabitat from 'react-habitat';

// import registerServiceWorker from './registerServiceWorker';

class MapData extends ReactHabitat.Bootstrapper {
	constructor() {
		super();

		// const chunk = 'true' === process.env.REACT_APP_CHUNK;
		const AppImport = () => import( './App' /*+ ( chunk ? '' : '/NoChunks.js' )*/ );

		// Create a new container builder
		const builder = new ReactHabitat.ContainerBuilder();

		const defaultProps = {
			latitude          : 42.95,
			longitude         : -85.7,
			googleKey         : process.env.REACT_APP_GOOGLE_API_KEY,
			showReset         : true,
			height            : '100%',
			heightMobile      : '100%',
			zoom              : 7,
			zoomMin           : 5,
			zoomMax           : 10,
			featurepad        : .15,
			backgroundImage   : '//www.woodtv.com/wp-content/uploads/sites/51/2020/04/Generic-Blue.png',
			keyHighlightColor : '#F9B619',
			popup             : false, // TODO make `true` open popups for features and markers in maps
			featureTooltip    : '', // TODO : Needs development. Disabled by default or specify what data will display.
			legendTitle       : 'Legend', // TODO : Allow changing default map legend title.
			legendNote        : '', // TODO : Can specify short text explaining legend figures.
		};

		// Register a component to load on demand asynchronously
		builder
			.registerAsync( AppImport )
			.as( 'MapData' )
			.withDefaultProps( {
				...defaultProps,
				useGoogleMaps : true,
			} );

		// Register another asynchronus component
		builder
			.registerAsync( AppImport )
			.as( 'MapDataGunThefts' )
			.withDefaultProps( {
				...defaultProps,
				title         : 'Gun Thefts',
				latitude      : 43.1,
				longitude     : -85.9,
				zoom          : 9,
				useGoogleMaps : true,
				useCached     : false,
				sheetId       : '1F0E1kLjWHKEJxrSqqy6iHvspoK3Lj82pK2dLCLacDYA',
				popup         : true,
			} );

		builder
			.registerAsync( AppImport )
			.as( 'MapDataBeachErosion' )
			.withDefaultProps( {
				...defaultProps,
				title             : 'Lake Michigan Beaches',
				latitude          : 43.1,
				longitude         : -85.9,
				zoom              : 8,
				zoomMax           : 14,
				zoomMin           : 4,
				useOpenStreetMaps : true,
				useCached         : true,
				showFullscreen    : true,
				sheetId           : '1iAhwojEKcx42_rj7sQHiWyYVA4kRF_lK2qnMrOwaTwM',
				popup             : true,
			} );

		builder
			.registerAsync( AppImport )
			.as( 'MapDataGRHomicides2020' )
			.withDefaultProps( {
				...defaultProps,
				title                   : '2020 Grand Rapids Homicides',
				latitude                : 42.95,
				longitude               : -85.7,
				zoom                    : 11,
				zoomMax                 : 15,
				zoomMin                 : 4,
				instructions            : 'Tap a map marker to see details related to that location on the map. The points on this map correspond to homicides, or deaths caused by people. Each death does not necessarily constitute the crime of murder in the state of Michigan.',
				useOpenStreetMaps       : true,
				useCached               : true,
				sheetMarkersTabName     : 'Markers',
				sheetMarkersDataTabName : 'MarkerData',
				sheetId                 : '1Ia1Dq-KZUvwXt07Apame7P4FdNHZDE3azDfBGB-XJHM',
				popup                   : true,
			} );

		// Register another asynchronus component
		const coronavirusMapConfig = {
			...defaultProps,
			sheetId                   : '1VKdasWv_XoYxiLxdjU2zUF2jY8X-TafpBUm3g-Uo2y4',
			title                     : 'COVID-19 Cases',
			backgroundImage           : '//www.woodtv.com/wp-content/uploads/sites/51/2021/04/Coronavirus-Background-1920x1080-2.jpg',
			geojsonName               : 'mi',
			sheetIdIsFeatureAttribute : 'NAME',
			tableStartColumn          : 1,
			sheetFeaturesTabName      : null,
			sheetOverallTabName       : 'Overall',
			sheetFeatureDataTabName   : 'Sheet1',
			useCached                 : true,
			autofit                   : true,
			featureOutlineColor       : '#FFFFFF',
			featureActiveOutlineColor : '#242424',
			choropleth                : true,
			choroplethAffector        : { table : 'Overall', quantity : { column : 2 }, ofSum : { column : 7 } },
			choroplethColorDefault    : '#818181',
			choroplethColorStops      : [
				{ stop : [ 1, 500 ], color : 'rgb(253,221,194)' },
				{ stop : [ 501, 1000 ], color : 'rgb(209,166,162)' },
				{ stop : [ 1001, 6000 ], color : 'rgb(178,97,107)' },
				{ stop : [ 6001, 15000 ], color : 'rgb(146,57,74)' },
				{ stop : [ 15001, 30000 ], color : 'rgb(119,13,37)' },
				{ stop : 1.00, color : 'rgb(51,3,14)' },
			],
		};

		builder
			.registerAsync( AppImport )
			.as( 'MapDataCoronavirus' )
			.withDefaultProps( coronavirusMapConfig );

		// Another
		builder
			.registerAsync( AppImport )
			.as( 'MapDataCoronavirusWI' )
			.withDefaultProps( {
				...coronavirusMapConfig,
				geojsonName          : 'wi',
				sheetId              : '1sGhOOHFGs9ch5c8N0-Yw-A8dVRpg9zEJC1Gb5mRTaF4',
				choroplethColorStops : [
					{ stop : [ 1, 10 ], color : 'rgb(253,221,194)' },
					{ stop : [ 11, 100 ], color : 'rgb(209,166,162)' },
					{ stop : [ 101, 300 ], color : 'rgb(178,97,107)' },
					{ stop : [ 301, 500 ], color : 'rgb(146,57,74)' },
					{ stop : [ 501, 3000 ], color : 'rgb(119,13,37)' },
					{ stop : 1.00, color : 'rgb(51,3,14)' },
				],
			} );

		// Register another asynchronus component
		builder
			.registerAsync( AppImport )
			.as( 'MapDataUnemployment' )
			.withDefaultProps( {
				...defaultProps,
				sheetId                   : '1XCZRvmC3EksZ5ZFKqzl2qPob9rNKTAllo7na2p-vGtk',
				title                     : 'Unemployment',
				geojsonName               : 'mi',
				sheetIdIsFeatureAttribute : 'NAME',
				tableStartColumn          : 7,
				sheetFeaturesTabName      : null,
				sheetOverallTabName       : 'Overall',
				sheetDataTabName          : 'Sheet1',
				useCached                 : true,
				autofit                   : true,
				featureOutlineColor       : '#FFFFFF',
				featureActiveOutlineColor : '#242424',
				choropleth                : true,
				choroplethAffector        : { table : 'Overall', quantity : { column : 8 }, ofSum : { column : 7 } },
				choroplethColorDefault    : '#818181',
				choroplethColorStops      : [
					{ stop : [ 1, 500 ], color : 'rgb(192, 207, 227)' },
					{ stop : [ 501, 1000 ], color : 'rgb(155, 177, 210)' },
					{ stop : [ 1001, 5000 ], color : 'rgb(120, 152, 195)' },
					{ stop : [ 5001, 15000 ], color : 'rgb(85, 128, 177)' },
					{ stop : [ 15001, 100000 ], color : 'rgb(67, 108, 163)' },
					{ stop : 1.00, color : 'rgb(43, 65, 119)' },
				],
			} );

		// Finally, set the container
		this.setContainer( builder.build() );
	}

}

new MapData();
